import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "filterButton"]

  filter(event) {
    const category = event.params.filter
    this.filterButtonTargets.forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.documentsFilterFilterParam === category)
    })
    this.itemTargets.forEach((item) => {
      const matches = category === "all" || item.dataset.category === category
      item.hidden = !matches
    })
  }
}
